/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CapturedElectronicSigningDetailsViewModel } from './CapturedElectronicSigningDetailsViewModel';
import {
    CapturedElectronicSigningDetailsViewModelFromJSON,
    CapturedElectronicSigningDetailsViewModelFromJSONTyped,
    CapturedElectronicSigningDetailsViewModelToJSON,
} from './CapturedElectronicSigningDetailsViewModel';
import type { DownloadAndSignOptionsViewModel } from './DownloadAndSignOptionsViewModel';
import {
    DownloadAndSignOptionsViewModelFromJSON,
    DownloadAndSignOptionsViewModelFromJSONTyped,
    DownloadAndSignOptionsViewModelToJSON,
} from './DownloadAndSignOptionsViewModel';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IAPSIGNINGOPTIONS } from './IAPSIGNINGOPTIONS';
import {
    IAPSIGNINGOPTIONSFromJSON,
    IAPSIGNINGOPTIONSFromJSONTyped,
    IAPSIGNINGOPTIONSToJSON,
} from './IAPSIGNINGOPTIONS';
import type { SigningError } from './SigningError';
import {
    SigningErrorFromJSON,
    SigningErrorFromJSONTyped,
    SigningErrorToJSON,
} from './SigningError';

/**
 * 
 * @export
 * @interface CapturedSigningDetailsViewModel
 */
export interface CapturedSigningDetailsViewModel {
    /**
     * 
     * @type {IAPSIGNINGOPTIONS}
     * @memberof CapturedSigningDetailsViewModel
     */
    signingMethod?: IAPSIGNINGOPTIONS;
    /**
     * 
     * @type {number}
     * @memberof CapturedSigningDetailsViewModel
     */
    productId: number;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof CapturedSigningDetailsViewModel
     */
    productCode: IAPPRODUCTCODE;
    /**
     * 
     * @type {string}
     * @memberof CapturedSigningDetailsViewModel
     */
    additionalInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof CapturedSigningDetailsViewModel
     */
    emailMessage?: string;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof CapturedSigningDetailsViewModel
     */
    partyTypeId: IAPPARTYTYPE;
    /**
     * 
     * @type {CapturedElectronicSigningDetailsViewModel}
     * @memberof CapturedSigningDetailsViewModel
     */
    electronicSigningDetails?: CapturedElectronicSigningDetailsViewModel;
    /**
     * 
     * @type {Array<IAPPARTYTYPE>}
     * @memberof CapturedSigningDetailsViewModel
     */
    ficaPartyTypes: Array<IAPPARTYTYPE>;
    /**
     * 
     * @type {boolean}
     * @memberof CapturedSigningDetailsViewModel
     */
    isSigningAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CapturedSigningDetailsViewModel
     */
    isESigningAllowed: boolean;
    /**
     * 
     * @type {Array<SigningError>}
     * @memberof CapturedSigningDetailsViewModel
     */
    missingInfoMessages: Array<SigningError>;
    /**
     * 
     * @type {DownloadAndSignOptionsViewModel}
     * @memberof CapturedSigningDetailsViewModel
     */
    downloadAndSignOptions: DownloadAndSignOptionsViewModel;
    /**
     * 
     * @type {string}
     * @memberof CapturedSigningDetailsViewModel
     */
    dateGenerated: string;
}

/**
 * Check if a given object implements the CapturedSigningDetailsViewModel interface.
 */
export function instanceOfCapturedSigningDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "productCode" in value;
    isInstance = isInstance && "partyTypeId" in value;
    isInstance = isInstance && "ficaPartyTypes" in value;
    isInstance = isInstance && "isSigningAllowed" in value;
    isInstance = isInstance && "isESigningAllowed" in value;
    isInstance = isInstance && "missingInfoMessages" in value;
    isInstance = isInstance && "downloadAndSignOptions" in value;
    isInstance = isInstance && "dateGenerated" in value;

    return isInstance;
}

export function CapturedSigningDetailsViewModelFromJSON(json: any): CapturedSigningDetailsViewModel {
    return CapturedSigningDetailsViewModelFromJSONTyped(json, false);
}

export function CapturedSigningDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapturedSigningDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signingMethod': !exists(json, 'SigningMethod') ? undefined : IAPSIGNINGOPTIONSFromJSON(json['SigningMethod']),
        'productId': json['ProductId'],
        'productCode': IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'additionalInstructions': !exists(json, 'AdditionalInstructions') ? undefined : json['AdditionalInstructions'],
        'emailMessage': !exists(json, 'EmailMessage') ? undefined : json['EmailMessage'],
        'partyTypeId': IAPPARTYTYPEFromJSON(json['PartyTypeId']),
        'electronicSigningDetails': !exists(json, 'ElectronicSigningDetails') ? undefined : CapturedElectronicSigningDetailsViewModelFromJSON(json['ElectronicSigningDetails']),
        'ficaPartyTypes': ((json['FicaPartyTypes'] as Array<any>).map(IAPPARTYTYPEFromJSON)),
        'isSigningAllowed': json['IsSigningAllowed'],
        'isESigningAllowed': json['IsESigningAllowed'],
        'missingInfoMessages': ((json['MissingInfoMessages'] as Array<any>).map(SigningErrorFromJSON)),
        'downloadAndSignOptions': DownloadAndSignOptionsViewModelFromJSON(json['DownloadAndSignOptions']),
        'dateGenerated': json['DateGenerated'],
    };
}

export function CapturedSigningDetailsViewModelToJSON(value?: CapturedSigningDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SigningMethod': IAPSIGNINGOPTIONSToJSON(value.signingMethod),
        'ProductId': value.productId,
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'AdditionalInstructions': value.additionalInstructions,
        'EmailMessage': value.emailMessage,
        'PartyTypeId': IAPPARTYTYPEToJSON(value.partyTypeId),
        'ElectronicSigningDetails': CapturedElectronicSigningDetailsViewModelToJSON(value.electronicSigningDetails),
        'FicaPartyTypes': ((value.ficaPartyTypes as Array<any>).map(IAPPARTYTYPEToJSON)),
        'IsSigningAllowed': value.isSigningAllowed,
        'IsESigningAllowed': value.isESigningAllowed,
        'MissingInfoMessages': ((value.missingInfoMessages as Array<any>).map(SigningErrorToJSON)),
        'DownloadAndSignOptions': DownloadAndSignOptionsViewModelToJSON(value.downloadAndSignOptions),
        'DateGenerated': value.dateGenerated,
    };
}

